import type { GameDescriptor } from '../game-registry.js';
import { MinesGameView } from '../mines/MinesGameView.js';

// protocol 'stateful' → GamePage renders MinesGameView instead of the single-shot path.
// `scene` is a thin wrapper that satisfies SceneComponent for the registry shape, but
// GamePage's stateful branch renders MinesGameView directly and never mounts `scene`.
export const minesDescriptor: GameDescriptor = {
  code: 'mines',
  protocol: 'stateful',
  supportsAuto: false,
  scene: MinesGameView as unknown as GameDescriptor['scene'],
};
